<template>
  <div class="send-quote">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">New Quote</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text mb-3"></v-divider>

          <v-form ref="form" lazy-validation @submit.prevent="sendQuote">
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="data.bid_amount"
                  label="Total Price*"
                  type="number"
                  min="1"
                  :rules="[v => !!v || 'Bid Amount is required']"
                  outlined
                  dense
                >
                </v-text-field>

                <v-text-field
                  v-model="data.bid_delivery_time"
                  label="Estimated Delivery Date*"
                  type="date"
                  outlined
                  dense
                  :rules="[v => !!v || 'Delivery Date is required']"
                >
                </v-text-field>

                <!-- <v-text-field
                  label="Upload Quote File*"
                  type="file"
                  outlined
                  dense
                  @change="setBidFile"
                  :rules="[v => !!v || 'Bid PDF File is required']"
                >
                </v-text-field> -->

                <v-row no-gutters align="center" class="mb-3">
                  <v-col cols="8" sm="9" md="9" lg="9">
                    <v-text-field
                      v-model="pickedFile.name"
                      desne
                      placeholder="Bid PDF File"
                      :rules="[v => !!v || 'Bid PDF File is required']"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="4"
                    sm="3"
                    md="3"
                    lg="3"
                    class="pl-sm-2 mt-2 mt-sm-0 text-lg-right"
                  >
                    <v-btn
                      color="black"
                      :block="$vuetify.breakpoint.mdAndDown"
                      dark
                      @click="uploadFile"
                      >Browse</v-btn
                    >
                    <input
                      ref="pickFile"
                      class="d-none"
                      type="file"
                      accept="application/pdf"
                      @change="onFilePick"
                    />
                  </v-col>
                </v-row>

                <v-textarea
                  v-model="data.comment"
                  label="Comment"
                  rows="3"
                  :rules="[v => !!v || 'Bid PDF File is required']"
                  no-resize
                  outlined
                  dense
                >
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  type="submit"
                  :loading="loading"
                  class="white--text mr-1"
                  depressed
                  ><v-icon class="mr-1" size="22">mdi-send</v-icon> Send</v-btn
                >
                <v-btn
                  color="black"
                  :disabled="loading"
                  outlined
                  depressed
                  @click="$emit('close')"
                  >Cancel</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    uploadFile() {
      this.$refs.pickFile.click();
    },
    onFilePick(e) {
      const files = [...e.target.files];
      this.pickedFile.name = null;
      this.pickedFile.file = null;
      if (files && files.length) {
        this.pickedFile.name = files[0].name;
        this.pickedFile.file = files[0];

        const reader = new FileReader();

        reader.onloadend = () => {
          this.data.bid_pdf = reader.result;
        };
        reader.readAsDataURL(files[0]);
      }
    },
    sendQuote() {
      if (this.$refs.form.validate()) {
        if (this.data.bid_pdf) {
          this.data.bid_pdf = this.data.bid_pdf.split(
            "data:application/pdf;base64,"
          )[1];
          const payload = { id: this.$route.params.id, ...this.data };
          this.loading = true;
          this.$store
            .dispatch("rfq/sendDealerQuote", payload)
            .then(() => {
              this.$emit("close");
              this.$emit("refresh");
            })
            .finally(() => {
              this.loading = false;
            });
        }
        console.log(this.data);
      }
    }
  },
  data() {
    return {
      loading: false,
      pickedFile: {
        name: null,
        file: null
      },
      data: {
        bid_amount: null,
        bid_pdf: null,
        bid_delivery_time: null,
        comment: null
      }
    };
  }
};
</script>
